import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeMfaDialog, performStepUpMfa, selectMfa } from 'src/common/store/mfa';
import { AppDispatch } from 'src/store/appStore';
import { MfaDialog } from './mfaDialog';

export const MfaStepUp: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { service, actionType, errorMessage, dialogState, dialogOpen, attemptsRemaining } = useSelector(selectMfa);

  useEffect(() => {
    if (dialogOpen && dialogState === 'success') {
      const timer = setTimeout(() => dispatch(closeMfaDialog()), 1000);
      return () => clearTimeout(timer);
    }
  }, [dialogOpen, dialogState, dispatch]);

  return (
    <MfaDialog
      open={dialogOpen}
      state={dialogState}
      errorMessage={errorMessage}
      attemptsRemaining={attemptsRemaining}
      onCancel={() => dispatch(closeMfaDialog())}
      onRetry={() => dispatch(performStepUpMfa({ service, actionType }))}
    />
  );
};
